import { render, staticRenderFns } from "./ArrayedSmsField.vue?vue&type=template&id=228db1e9&"
import script from "./ArrayedSmsField.vue?vue&type=script&lang=js&"
export * from "./ArrayedSmsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports